import React, {Component} from "react";
import {connect} from "react-redux";
import {Translate} from "react-i18nify";

import * as componentTypes from "../../../../constants/componentTypes";
import * as modelHelper from "../../../../helpers/modelHelper";
import * as navigationActions from "../../../../actions/navigationActions";

import Modal from "../../../global/generic/Modal";
import CancelButton from "../../../global/generic/CancelButton";

class MeasurementDetailModal extends Component {
    handleCloseModalClick = () => {
        this.props.dispatchCloseModalAction();
    };

    getLabResult = () => {
        let lab = [];

        lab.push(
            <div key="2" className="col-2">
                <div className="color-primary pull-left margin-right-5">L: </div>
                <div className="pull-left">{this.props.params.lab.L}</div>
            </div>
        );

        lab.push(
            <div key="3" className="col-2">
                <div className="color-primary pull-left margin-right-5">a:</div>
                <div className="pull-left">{this.props.params.lab.a}</div>
            </div>
        );

        lab.push(
            <div key="4" className="col-2">
                <div className="color-primary pull-left margin-right-5">b:</div>
                <div className="pull-left">{this.props.params.lab.b}</div>
            </div>
        );

        return lab;
    };

    getRgbResult = () => {
        let rgb = [];

        rgb.push(
            <div key="6" className="col-2">
                <div className="color-primary pull-left margin-right-5">R:</div>
                <div className="pull-left">{this.props.params.rgb.R}</div>
            </div>
        );

        rgb.push(
            <div key="7" className="col-2">
                <div className="color-primary pull-left margin-right-5">G:</div>
                <div className="pull-left">{this.props.params.rgb.G}</div>
            </div>
        );

        rgb.push(
            <div key="8" className="col-2">
                <div className="color-primary pull-left margin-right-5">B:</div>
                <div className="pull-left">{this.props.params.rgb.B}</div>
            </div>
        );

        return rgb;
    };

    getXyzResult = () => {
        let xyz = [];

        xyz.push(
            <div key="9" className="col-2">
                <div className="color-primary pull-left margin-right-5">X: </div>
                <div className="pull-left">{this.props.params.xyz.X}</div>
            </div>
        );

        xyz.push(
            <div key="10" className="col-2">
                <div className="color-primary pull-left margin-right-5">Y:</div>
                <div className="pull-left">{this.props.params.xyz.Y}</div>
            </div>
        );

        xyz.push(
            <div key="11" className="col-2">
                <div className="color-primary pull-left margin-right-5">Z:</div>
                <div className="pull-left">{this.props.params.xyz.Z}</div>
            </div>
        );

        return xyz;
    };

    getContent = () => {
        return modelHelper.buildModalSection(
            <div className="col-12">
                <div className="col-12 flex padding-top-10">
                    <div className="col-3">
                        <div className="pull-left color-primary">Lab D65/10: </div>
                    </div>
                    {this.getLabResult()}
                </div>
                <div className="col-12 flex padding-top-10">
                    <div className="col-3">
                        <div className="pull-left color-primary">RGB (sRGB):</div>
                    </div>
                    {this.getRgbResult()}
                </div>
                <div className="col-12 flex padding-top-10">
                    <div className="col-3">
                        <div className=" pull-left color-primary">XYZ D65/10: </div>
                    </div>
                    {this.getXyzResult()}
                </div>
                <div className="col-12 flex padding-top-10">
                    <div className="col-3">
                        <div className=" pull-left color-primary">RGB (hex):</div>
                    </div>
                    <div className="col-2">
                        <div className="pull-left">{this.props.params.rgbHex}</div>
                    </div>
                </div>
            </div>
        );
    };

    getFooter = () => {
        return modelHelper.buildModalSection(<CancelButton onClick={this.handleCloseModalClick} />);
    };

    render() {
        return (
            <Modal
                onClose={this.handleCloseModalClick}
                header={modelHelper.buildModalSection(<Translate value="spectroTab.measurementResult" />)}
                content={this.getContent()}
                footer={this.getFooter()}
                styles={{minWidth: "60%"}}
            />
        );
    }
}

const mapStoreToProps = () => {
    return {};
};

const mapDispatchToProps = (dispatch) => {
    return {
        dispatchCloseModalAction: () => {
            dispatch(navigationActions.closeModal(componentTypes.SPECTRO_MEASUREMENT_DETAIL_MODAL));
        }
    };
};

export default MeasurementDetailModal = connect(mapStoreToProps, mapDispatchToProps)(MeasurementDetailModal);
